/* @flow */
import * as React from 'react';

import ProductionInfo from 'components/ProductionInfo';
import styles from './styles.module.scss';

import type { Usage } from 'types';

import { get } from 'lodash';

type Props = Usage;

class UsageInfo extends React.PureComponent<Props, void> {
  render() {
    const {
      id,
      uuid,
      name,
      status,
      createDate,
      modifiedDate,
      startDate,
      endDate,
      exclusive,
      exclusiveEndDate,
      exclusiveNotes,
      production,
      episode,
      notes,
      channel,
      broadcasting,
      platform,
      broadcastType,
      territory,
      type,
      usageType,
    } = this.props;
    const description = `
      usageBoxId: ${id}
      uuid: ${uuid}
      nome: ${name}
      status: ${status ? 1 : 0}
      createDate: ${createDate && new Date(createDate).toISOString()}
      modifiedDate: ${modifiedDate && new Date(modifiedDate).toISOString()}
      startDate: ${(startDate && new Date(startDate).toISOString()) || ''}
      endDate: ${(endDate && new Date(endDate).toISOString()) || ''}
      esclusiva: ${exclusive ? 1 : 0}
      exclusiveEndDate: ${(exclusiveEndDate && new Date(exclusiveEndDate).toISOString()) || ''}
      exclusiveNotes: ${exclusiveNotes || ''}
      puntata: ${episode || ''}
      note: ${notes || ''}
      channel: ${get(channel, 'name')}
      channelId: ${get(channel, 'id')}
      broadcastType: ${get(broadcastType, 'name')}
      broadcastTypeId: ${get(broadcastType, 'id')}
      broadcasting: ${get(broadcasting, 'name')}
      broadcastingId: ${get(broadcasting, 'id')}
      platform: ${get(platform, 'name')}
      platformId: ${get(platform, 'id')}
      territorioId: ${get(territory, 'id')}
      territorio: ${get(territory, 'name')}
      tipoId: ${type || ''}
      tipologiaUtilizzoId: ${get(usageType, 'id')}
      tipologiaUtilizzo: ${get(usageType, 'name')}
    `;
    const paragraphs = description
      .split('\n')
      .map((paragraph, index) => <p key={`${index}_${paragraph.substring(0, 5)}`}>{paragraph}</p>);
    return (
      <div className={styles.container}>
        {paragraphs}
        <p>
          {'Produzione: '}
          {production ? <ProductionInfo {...production} /> : 'NESSUNA PRODUZIONE'}
        </p>
      </div>
    );
    // return (
    //   <div className={styles.container}>
    //     <dl>
    //       <dt>{'usageBoxId:'}</dt>
    //       <dd>{id}</dd>
    //       <dt>{'uuid:'}</dt>
    //       <dd>{uuid}</dd>
    //       <dt>{'nome:'}</dt>
    //       <dd>{name}</dd>
    //       <dt>{'status:'}</dt>
    //       <dd>{status}</dd>
    //       <dt>{'createDate:'}</dt>
    //       <dd>{createDate && new Date(createDate).toISOString()}</dd>
    //       <dt>{'modifiedDate:'}</dt>
    //       <dd>{modifiedDate && new Date(modifiedDate).toISOString()}</dd>
    //       <dt>{'dataInizioUtilizzo:'}</dt>
    //       <dd>{startDate && new Date(startDate).toISOString()}</dd>
    //       <dt>{'dataFineUtilizzo:'}</dt>
    //       <dd>{endDate && new Date(endDate).toISOString()}</dd>
    //       <dt>{'esclusiva:'}</dt>
    //       <dd>{exclusive}</dd>
    //       <dt>{'puntata:'}</dt>
    //       <dd>{episode}</dd>
    //       <dt>{'quantita:'}</dt>
    //       <dd>{quantity}</dd>
    //       <dt>{'note:'}</dt>
    //       <dd>{notes}</dd>
    //       <dt>{'territorioId:'}</dt>
    //       <dd>{get(territory, 'id')}</dd>
    //       <dt>{'territorio:'}</dt>
    //       <dd>{get(territory, 'name')}</dd>
    //       <dt>{'tipoId:'}</dt>
    //       <dd>{type}</dd>
    //       <dt>{'tipologiaUtilizzoId:'}</dt>
    //       <dd>{get(usageType, 'id')}</dd>
    //       <dt>{'tipologiaUtilizzo:'}</dt>
    //       <dd>{get(usageType, 'name')}</dd>
    //       <hr />
    //       <dt>{'Produzione:'}</dt>
    //       {production ? <ProductionInfo {...production} /> : 'NESSUNA PRODUZIONE'}
    //     </dl>
    //   </div>
    // );
  }
}

export default UsageInfo;
